import { defaultColors } from '@/constants/graphics';

const monthsFR = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
const shortMonthsFR = ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];
const daysFR = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
const shortDaysFR = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
const toolbarFR = {
    exportToSVG: 'Télécharger SVG',
    exportToPNG: 'Télécharger PNG',
    exportToCSV: 'Télécharger CSV',
    menu: 'Menu',
    selection: 'Sélection',
    selectionZoom: 'Zoom Sélection',
    zoomIn: 'Agrandir',
    zoomOut: 'Réduire',
    pan: 'Déplacer',
    reset: 'Réinitialiser Zoom',
};

const monthEN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const shortMonthEN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dayEN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const shortDayEN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const toolbarEN = {
    exportToSVG: 'Download SVG',
    exportToPNG: 'Download PNG',
    exportToCSV: 'Download CSV',
    menu: 'Menu',
    selection: 'Selection',
    selectionZoom: 'Selection Zoom',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    pan: 'Panning',
    reset: 'Reset Zoom',
};

export const enLocaleData = {
    dateTime: '%x, %X',
    date: '%-m/%-d/%Y',
    time: '%-I:%M:%S %p',
    periods: ['AM', 'PM'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: monthEN,
    shortMonths: shortMonthEN,
};

export const frLocaleData = {
    dateTime: '%A, %e %B %Y, %X',
    date: '%d/%m/%Y',
    time: '%H:%M:%S',
    periods: ['', ''],
    days: daysFR,
    shortDays: shortDaysFR,
    months: monthsFR,
    shortMonths: shortMonthsFR,
};

export const seriesChartOptions = (chartId, lang) => ({
    chart: {
        id: chartId,
        animations: {
            enabled: false,
        },
        type: 'line',
        toolbar: {
            show: true,
            tools: {
                download: true,
                selection: true,
                zoom: false,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: false,
            },
        },
        locales: [{
            name: 'fr',
            options: {
                months: monthsFR,
                shortMonths: shortMonthsFR,
                days: daysFR,
                shortDays: shortDaysFR,
                toolbar: toolbarFR,
            },
        }, {
            name: 'en',
            options: {
                months: monthEN,
                shortMonths: shortMonthEN,
                days: dayEN,
                shortDays: shortDayEN,
                toolbar: toolbarEN,
            },
        }],
        defaultLocale: lang,
    },
    markers: {
        size: 0,
    },
    legend: {
        showForSingleSeries: true,
    },
    colors: defaultColors,
    grid: {
        row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
        },
    },
    tooltip: {
        y: {
            formatter(value, { seriesIndex, dataPointIndex, w }) {
                const { norm } = w.config.series[seriesIndex].data[dataPointIndex];
                const msg = norm ? `(${norm})` : '';
                return `${value}  ${msg}`;
            },
        },
    },
    xaxis: {
        type: 'datetime',
        labels: {
            datetimeUTC: false,
        },
    },
});

export const seriesNormsChartOptions = (serieId, targetId, lang) => ({
    chart: {
        id: serieId,
        type: 'line',
        animations: {
            enabled: false,
        },
        brush: {
            target: targetId,
            enabled: true,
        },
        selection: {
            enabled: true,
            type: 'x',
            fill: {
                color: '#26384b',
                opacity: 0.3,
            },
        },
        toolbar: {
            show: false,
        },
        locales: [{
            name: 'fr',
            options: {
                months: monthsFR,
                shortMonths: shortMonthsFR,
                days: daysFR,
                shortDays: shortDaysFR,
                toolbar: toolbarFR,
            },
        },
        {
            name: 'en',
            options: {
                months: monthEN,
                shortMonths: shortMonthEN,
                days: dayEN,
                shortDays: shortDayEN,
                toolbar: toolbarEN,
            },
        },

        ],
        defaultLocale: lang,
    },
    markers: {
        size: 0,
    },
    colors: defaultColors,
    grid: {
        row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
        },
    },
    xaxis: {
        type: 'datetime',
        tooltip: {
            enabled: false,
        },
        labels: {
            datetimeUTC: false,
        },
    },
    yaxis: {
        tickAmount: 2,
    },
});
